export const LONG_DATE_FORMAT = 'dddd, MMMM Do YYYY';
export const SHORT_DATE_FORMAT = 'Do MMM YY';

export const formatDateForDisplay = date => date.format(LONG_DATE_FORMAT);
export const formatDateForShortDisplay = date => date.format(SHORT_DATE_FORMAT);

export const getMonthFromDate = date => date.format('MMMM');
export const getMonthWithYearFromDate = date => date.format('MMMM YYYY');
